import React from "react";
import { Priceable } from "../../../Types";
import { Quotation } from "../../../../../stores/CoursePreviewStore/Types";
import AppliedVoucher from "../AppliedVoucher";
import PriceAmount, { CurrencyAmount } from "../PriceAmount";

interface Props {
  priceable: Priceable;
  activeQuote: Quotation;
  couponCode: string;
  refCode: string;
  amount: string;
  discountAmount: string;
  monthlySubsequentPayment: string;
  refreshQuoteWithoutCoupon: (e: any) => void;
}

const Monthly: React.FC<Props> = ({
  priceable,
  activeQuote,
  couponCode,
  refCode,
  amount,
  discountAmount,
  monthlySubsequentPayment,
  refreshQuoteWithoutCoupon,
}) => {
  return (
    <>
      {activeQuote?.amount > 0 && (
        <div id="priceBreakdown">
          <div className="price-line">
            <span>Monthly payment</span>
            <span>
              <strong>
                <CurrencyAmount
                  quote={activeQuote}
                  amount={monthlySubsequentPayment}
                />
              </strong>
            </span>
          </div>

          <div className="price-line">
            <span>Duration</span>
            <span>12 monthly payments</span>
          </div>
          <div className="price-line commitment">
            <span>Total (12 months)</span>
            <div className="price-right">
              <span>
                <CurrencyAmount quote={activeQuote} amount={amount} />
              </span>
              {activeQuote?.discounted && discountAmount && (
                <div className="discount-note">
                  Save{" "}
                  <CurrencyAmount quote={activeQuote} amount={discountAmount} />
                </div>
              )}
            </div>
          </div>
          <AppliedVoucher
            couponCode={couponCode}
            refCode={refCode}
            refreshQuoteWithoutCoupon={refreshQuoteWithoutCoupon}
          />
          <div className="price-line total">
            <span>Today's charge</span>
            <div className="price-right">
              <PriceAmount quote={activeQuote} />
              <div className="monthly-note">
                then 11 ×{" "}
                <CurrencyAmount
                  quote={activeQuote}
                  amount={monthlySubsequentPayment}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="whats-included" id="whatsIncluded">
        <h4>What you get</h4>
        <ul>
          <li>All 40+ CPD-accredited Mini MBA courses</li>
          <li>Community Hub access</li>
          <li>AI toolkit and swipe file</li>
          <li>New courses as they launch</li>
          <li>Price locked in, never goes up while you stay subscribed</li>
        </ul>
      </div>
    </>
  );
};

export default Monthly;
